<template>
    <!-- theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <RegisterLoginPopup ref="registerLoginRef" v-model:show="show" :data-set="dataSet" @open="open" @close="close"
            @captcha-chage="captchaChage" @change-sign-type="changeSignType"
            @confirm-password-change="confirmPasswordChange" @email-change="emailChange"
            @email-o-t-p-change="emailOTPChange" @get-captcha-image-data="getCaptchaImageData"
            @get-email-o-t-p="getEmailOTP" @get-s-m-s-o-t-p="getSMSOTP" @get-whatsapp-o-t-p="getWhatsappOTP"
            @password-change="passwordChange" @phone-number-change="phoneNumberChange" @sign-in="signIn"
            @sign-up="signUp" @sms-o-t-p-change="smsOTPChange" @whatsapp-o-t-p-change="whatsappOTPChange"
            @turnstile-token-change="turnstileTokenChange" @turnstile-error="turnstileError" />
    </div>
    <div v-if="themeStore.themeIndex === 2">
        <RegisterLoginPopupThemeTwo ref="registerLoginRef" v-model:show="show" :data-set="dataSet" @open="open"
            @close="close" @captcha-chage="captchaChage" @change-sign-type="changeSignType"
            @confirm-password-change="confirmPasswordChange" @email-change="emailChange"
            @email-o-t-p-change="emailOTPChange" @get-captcha-image-data="getCaptchaImageData"
            @get-email-o-t-p="getEmailOTP" @get-s-m-s-o-t-p="getSMSOTP" @get-whatsapp-o-t-p="getWhatsappOTP"
            @password-change="passwordChange" @phone-number-change="phoneNumberChange" @sign-in="signIn"
            @sign-up="signUp" @sms-o-t-p-change="smsOTPChange" @whatsapp-o-t-p-change="whatsappOTPChange"
            @turnstile-token-change="turnstileTokenChange" @turnstile-error="turnstileError" />
    </div>
    <div  v-if="themeStore.themeIndex === 3">
        <RegisterLoginPopupThemeThree ref="registerLoginRef" v-model:show="show" :data-set="dataSet" @open="open" @close="close"
            @captcha-chage="captchaChage" @change-sign-type="changeSignType"
            @confirm-password-change="confirmPasswordChange" @email-change="emailChange"
            @email-o-t-p-change="emailOTPChange" @get-captcha-image-data="getCaptchaImageData"
            @get-email-o-t-p="getEmailOTP" @get-s-m-s-o-t-p="getSMSOTP" @get-whatsapp-o-t-p="getWhatsappOTP"
            @password-change="passwordChange" @phone-number-change="phoneNumberChange" @sign-in="signIn"
            @sign-up="signUp" @sms-o-t-p-change="smsOTPChange" @whatsapp-o-t-p-change="whatsappOTPChange" 
            @turnstile-token-change="turnstileTokenChange" @turnstile-error="turnstileError" />
    </div>
    <div  v-if="themeStore.themeIndex === 4">
        <RegisterLoginPopupThemeFour ref="registerLoginRef" v-model:show="show" :data-set="dataSet" @open="open" @close="close"
            @captcha-chage="captchaChage" @change-sign-type="changeSignType"
            @confirm-password-change="confirmPasswordChange" @email-change="emailChange"
            @email-o-t-p-change="emailOTPChange" @get-captcha-image-data="getCaptchaImageData"
            @get-email-o-t-p="getEmailOTP" @get-s-m-s-o-t-p="getSMSOTP" @get-whatsapp-o-t-p="getWhatsappOTP"
            @password-change="passwordChange" @phone-number-change="phoneNumberChange" @sign-in="signIn"
            @sign-up="signUp" @sms-o-t-p-change="smsOTPChange" @whatsapp-o-t-p-change="whatsappOTPChange" 
            @turnstile-token-change="turnstileTokenChange" @turnstile-error="turnstileError" />
    </div>
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />
</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { getCaptchaCode, getEmailOtpCode, getSmsOtpCode, getWhatsappOtpCode, login, register } from '@/api/user';
import { useUserStore } from '@/stores/user';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { initSSE } from '@/utils/sse';
import { useGameStore } from '@/stores/games';
import { useI18n } from 'vue-i18n';
import RegisterLoginPopup from '@/themes/themeOne/loginRegister/registerLoginPopup.vue';
import RegisterLoginPopupThemeTwo from '@/themes/themeTwo/loginRegister/registerLoginPopup.vue';
import RegisterLoginPopupThemeThree from '@/themes/themeThree/loginRegister/registerLoginPopup.vue';
import RegisterLoginPopupThemeFour from '@/themes/themeFour/loginRegister/registerLoginPopup.vue';
import { RegisterLoginData } from './supportScript';
import { useThemeStore } from '@/stores/theme'
import type { ApiError } from '@/types/common'
import { loadLanguage } from '@/i18n';

const { t } = useI18n()
const userStore = useUserStore()
const gameStore = useGameStore()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const show = ref(false)
const registerLoginRef = ref()
const themeStore = useThemeStore()
type FbqFunction = (...args: any[]) => void

const phoneNumber = ref('')
const email = ref('')
const password = ref('')
const confirmPassword = ref('')
const smsOTP = ref('')
const whatsappOTP = ref('')
const emailOTP = ref('')
const agentKey = ref('')
const emailValidationNotice = ref(false)
const phoneValidationNotice = ref(false)
const passwordValidationNotice = ref(false)
const confirmPasswordValidationNotice = ref(false)
const signType = ref(0)
const isPWA = ref(false);
const isShowCaptcha = ref(false)
const captcha = ref('')
const captchaImg = ref('')
const uuid = ref('')
const showSMSOTP = ref(false)
const showEmailOTP = ref(false)
const showWhatsappOTP = ref(false)
const cloudFlareCaptchaEnabled = ref(false)
const cloudFlareSiteKey = ref('')
const turnstileToken = ref('')
const sliderEnabled = ref(false)
const isLoading = ref(false)
const showEmailOTPForgetPassword = ref(false)
const showWhatsappOTPForgetPassword = ref(false)
const showMobileOTPForgetPassword = ref(false)
const showCaptchaEnabledForgetPassword = ref(false)

const dataSet = computed<RegisterLoginData>(() => ({
    phoneNumber: phoneNumber.value,
    email: email.value,
    password: password.value,
    confirmPassword: confirmPassword.value,
    smsOTP: smsOTP.value,
    whatsappOTP: whatsappOTP.value,
    emailOTP: emailOTP.value,
    emailValidationNotice: emailValidationNotice.value,
    phoneValidationNotice: phoneValidationNotice.value,
    passwordValidationNotice: passwordValidationNotice.value,
    confirmPasswordValidationNotice: confirmPasswordValidationNotice.value,
    show: show.value,
    signType: signType.value,
    isShowCaptcha: isShowCaptcha.value,
    captcha: captcha.value,
    captchaImg: captchaImg.value,
    showSMSOTP: showSMSOTP.value,
    showEmailOTP: showEmailOTP.value,
    showWhatsappOTP: showWhatsappOTP.value,
    cloudFlareCaptchaEnabled: cloudFlareCaptchaEnabled.value,
    cloudFlareSiteKey: cloudFlareSiteKey.value,
    sliderEnabled: sliderEnabled.value,
    isRegisterBtnActive: isRegisterBtnActive.value,
    isLoginBtnActive: isLoginBtnActive.value,
    isLoading: isLoading.value,
    showEmailOTPForgetPassword: showEmailOTPForgetPassword.value,
    showWhatsappOTPForgetPassword: showWhatsappOTPForgetPassword.value,
    showCaptchaEnabledForgetPassword: showCaptchaEnabledForgetPassword.value,
    showMobileOTPForgetPassword: showMobileOTPForgetPassword.value
}))
const isRegisterBtnActive = computed(() => {
    if (signType.value === 0) {
        let captchaValidation = isShowCaptcha.value ? captcha.value.length > 0 : true
        let turnstileValidation = cloudFlareCaptchaEnabled.value ? turnstileToken.value.length > 0 : true
        return (
            phoneNumber.value.length > 0 &&
            password.value.length > 0 &&
            confirmPassword.value.length > 0 &&
            captchaValidation &&
            turnstileValidation &&
            !phoneValidationNotice.value &&
            !passwordValidationNotice.value &&
            !confirmPasswordValidationNotice.value
        );
    }
    return false;
});

const isLoginBtnActive = computed(() => {
    if (signType.value === 1) {
        let captchaValidation = isShowCaptcha.value ? captcha.value.length > 0 : true
        let turnstileValidation = cloudFlareCaptchaEnabled.value ? turnstileToken.value.length > 0 : true
        return (
            phoneNumber.value.length > 0 &&
            password.value.length > 0 &&
            captchaValidation &&
            turnstileValidation &&
            !phoneValidationNotice.value &&
            !passwordValidationNotice.value
        );
    } else if(signType.value === 2) {
        return true;
    }
    return false;
});

const open = (type: number) => {
    show.value = true
    signType.value = type
    getCaptchaImageData();
}

const close = () => {
    show.value = false
}

const changeSignType = (value: number) => {
    resetForm();
    signType.value = value
    if (value !== 2) { // Don't fetch captcha for forget password
        getCaptchaImageData();
    }
    getForgetPasswordDetails()
}

const phoneNumberChange = (value: string) => {
    phoneNumber.value = value
    checkPhoneValidation(value)
}

const smsOTPChange = (value: string) => {
    smsOTP.value = value
}
const whatsappOTPChange = (value: string) => {
    whatsappOTP.value = value
}
const emailChange = (value: string) => {
    email.value = value
    checkEmailValidation(value)
}

const emailOTPChange = (value: string) => {
    emailOTP.value = value
}

const passwordChange = (value: string) => {
    password.value = value
    checkPasswordValidation(value)
    confirmPasswordChange(confirmPassword.value)
}

const confirmPasswordChange = (value: string) => {
    confirmPassword.value = value
    checkConfirmPasswordValidation(value)
}
const captchaChage = (value: string) => {
    captcha.value = value
}
const turnstileTokenChange = (value: string) => {
    turnstileToken.value = value
}
const turnstileError = (value: string) => {
    console.error("Turnstile Error:", value);
}

const checkPhoneValidation = (value: any) => {
    if (value.length == 11 && value[2] == '9' || value.length == 0) {

        phoneValidationNotice.value = false
    } else {
        phoneValidationNotice.value = true
    }
}

const checkPasswordValidation = (value: any) => {
    if (value.length >= 8 && value.length <= 20 || value.length == 0) {
        passwordValidationNotice.value = false
    } else {
        passwordValidationNotice.value = true
    }
}
const checkConfirmPasswordValidation = (value: any) => {
    if (value.length >= 8 && value.length <= 20) {
        if (confirmPassword.value !== password.value) {
            confirmPasswordValidationNotice.value = true
        } else {
            confirmPasswordValidationNotice.value = false
        }
    }else if(value.length == 0){
        confirmPasswordValidationNotice.value = false
    } else {
        confirmPasswordValidationNotice.value = true
    }
}
const checkEmailValidation = (value: any) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (regex.test(email.value)) {
        emailValidationNotice.value = false
    } else {
        emailValidationNotice.value = true
    }
}
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}
const signIn = (isReg: boolean, captchaData?: any) => {
    if (!isReg) {
        loadingRef.value.open();
        isLoading.value = true
    }
    const params = {
        username: phoneNumber.value,
        code: captcha.value,
        grantType: "password",
        password: password.value,
        rememberMe: false,
        tenantId: process.env.VUE_APP_TENANT_ID,
        clientId: process.env.VUE_APP_CLIENT_ID,
        uuid: uuid.value,
        captcha: isShowCaptcha.value ? (isReg ? false : true) : false,
        turnstileToken: turnstileToken.value,
        sliderCaptchaId: captchaData?.captchaId
    }
    login(params).then(res => {
        loadingRef.value.close()
        isLoading.value = false
        setTimeout(() => {
            if (!isReg) {
                showSuccess(res.msg);
            }
            show.value = false;
        }, 500)
        localStorage.setItem('token', res.data.access_token);
        if(res.data.pixel_id && res.data.pixel_id !== null){
           localStorage.setItem('fbPixelId', res.data.pixel_id)
          }
        if(res.data.channel_code && res.data.channel_code !== null){
           localStorage.setItem('fbChannelCode', res.data.channel_code)
         }
        initSSE(process.env.VUE_APP_BASE_API + '/app/resource/sse');
        gameStore.getGameGroupListData()
        userStore.getInfo();
        loadLanguage("pt")
        localStorage.removeItem('inviteRefCode')
        initFacebookPixel('signin')
    }).catch((err: ApiError | string) => {
        loadingRef.value.close()
        isLoading.value = false
        if (typeof err === 'string') {
            showError(err);
        } else if (err.i18nKey) {
            showError(`${t(err.i18nKey, { loginNumber: phoneNumber.value })}`);
        } else {
            showError(err.msg || t('common.error'));
        }
    })
}
const signUp = (captchaData?: any) => {
    loadingRef.value.open()
    const params = new URLSearchParams(window.location.hash.split('?')[1] || '')
    agentKey.value = params.get('ref') || ''
    const inviteRefCode = localStorage.getItem('inviteRefCode')
    if (inviteRefCode) {
        agentKey.value = inviteRefCode
    }
    const data = {
        username: phoneNumber.value,
        password: password.value,
        userType: "app_user",
        registerType: "mobile",
        agentKey: agentKey.value,
        isApp: 1,
        isPwa: 0,
        isApk: 0,
        grantType: "password",
        tenantId: process.env.VUE_APP_TENANT_ID,
        clientId: process.env.VUE_APP_CLIENT_ID,
        uuid: uuid.value,
        code: captcha.value,
        areaCode: "55",
        email: email.value,
        emailOtp: emailOTP.value,
        smsOtp: smsOTP.value,
        whatsAppOtp: whatsappOTP.value,
        turnstileToken: turnstileToken.value,
        sliderCaptchaId: captchaData?.captchaId
    }
    register(data).then(res => {
        loadingRef.value.close()
        setTimeout(() => {
            showSuccess(res.msg);
            signIn(true)
            loadLanguage("pt")
            // signType.value = 1;
        }, 500)
        initFacebookPixel('signup')
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
        getCaptchaImageData()
        if (registerLoginRef.value && registerLoginRef.value.resetTurnstile) {
            registerLoginRef.value.resetTurnstile()
        }
    })
}

const initFacebookPixel = (type: string): void => {
    if (localStorage.getItem('fbPixelId')) {
        if (typeof window.fbq === 'function') return

            ; (function (f: any, b: Document, e: string, v: string, n?: any, t?: any, s?: any) {
                if (typeof f.fbq === 'function') return

                n = f.fbq = function (...args: any[]) {
                    n.callMethod ? n.callMethod(...args) : n.queue.push(args)
                }

                n.loaded = true
                n.version = '2.0'
                n.queue = []

                t = b.createElement(e)
                t.async = true
                t.src = v
                s = b.getElementsByTagName(e)[0]
                s.parentNode?.insertBefore(t, s)
            })(
                window,
                document,
                'script',
                'https://connect.facebook.net/en_US/fbevents.js'
            )

            ; (window.fbq as FbqFunction)('init', localStorage.getItem('fbPixelId'))
            if (type === 'signup') {
                (window.fbq as FbqFunction)('track', 'CompleteRegistration')
            } else if (type === 'signin') {
                (window.fbq as FbqFunction)('trackCustom', 'LoginUser')
            }
    }
}

const getCaptchaImageData = () => {
    getCaptchaCode().then(res => {
        loadingRef.value.close()
        isShowCaptcha.value = res.data?.captchaEnabled || false
        showSMSOTP.value = res.data?.smsEnabled || false
        showEmailOTP.value = res.data?.emailEnabled || false
        showWhatsappOTP.value = res.data?.whatsAppEnabled || false
        cloudFlareCaptchaEnabled.value = res.data?.cloudFlareCaptchaEnabled || false
        cloudFlareSiteKey.value = res.data?.cloudFlareSiteKey || ''
        sliderEnabled.value = res.data?.sliderEnabled || false
        captchaImg.value = 'data:image/png;base64,' + res.data?.img
        uuid.value = res.data?.uuid || ''
        showEmailOTPForgetPassword.value = res.data?.forgetPasswordEmailEnabled == 1 ? true : false
        showCaptchaEnabledForgetPassword.value = res.data?.forgetPasswordCaptchaEnabled
        showWhatsappOTPForgetPassword.value = res.data?.forgetPasswordSmsMethod == 'WHATSAPP' ? true : false
        showMobileOTPForgetPassword.value = res.data?.forgetPasswordSmsMethod == 'SMS' ? true : false
    }).catch(err => {
        loadingRef.value.close()
        showError(err);
    })
}

const getForgetPasswordDetails = () => {
    // getForgetPasswordInfo().then(res => {
    //     loadingRef.value.close()
        
    // }).catch(err => {
    //     loadingRef.value.close()
    //     showError(err);
    // })
}

onBeforeMount(() => {
    isPWA.value = window.matchMedia('(display-mode: standalone)').matches ||
        (window.navigator.standalone === true) ||
        document.referrer.includes('android-app://');
})

const getSMSOTP = () => {
    if (phoneNumber.value && !phoneValidationNotice.value) {
        let params = {
            phone: phoneNumber.value
        }
        getSmsOtpCode(params).then(res => {
            loadingRef.value.close()
            registerLoginRef.value.handleStopLoading('sms')
            registerLoginRef.value.handleStartCountdown('sms')
        }).catch(err => {
            registerLoginRef.value.handleStopLoading('sms')
            loadingRef.value.close()
            showError(err);
        })
    } else {
        registerLoginRef.value.handleStopLoading('sms')
        showError(t('profile.phoneNum'));
    }

}

const getWhatsappOTP = () => {
    if (phoneNumber.value && !phoneValidationNotice.value) {
        let params = {
            phone: phoneNumber.value
        }
        getWhatsappOtpCode(params).then(res => {
            loadingRef.value.close()
            registerLoginRef.value.handleStopLoading('whatsapp')
            registerLoginRef.value.handleStartCountdown('whatsapp')
        }).catch(err => {
            loadingRef.value.close()
            registerLoginRef.value.handleStopLoading('whatsapp')
            showError(err);
        })
    } else {
        registerLoginRef.value.handleStopLoading('whatsapp')
        showError(t('profile.phoneNum'));
    }

}

const getEmailOTP = () => {
    if (email.value && !emailValidationNotice.value) {
        let params = {
            email: email.value,
            phone: phoneNumber.value
        }
        getEmailOtpCode(params).then(res => {
            loadingRef.value.close()
            registerLoginRef.value.handleStopLoading('email')
            registerLoginRef.value.handleStartCountdown('email')
        }).catch(err => {
            loadingRef.value.close()
            registerLoginRef.value.handleStopLoading('email')
            showError(err);
        })
    } else {
        registerLoginRef.value.handleStopLoading('email')
        showError(t('loginRegister.enteremail'));
    }
}
const resetForm = () => {
    phoneNumber.value = '';
    email.value = '';
    password.value = '';
    confirmPassword.value = '';
    smsOTP.value = '';
    whatsappOTP.value = '';
    emailOTP.value = '';
    captcha.value = '';
    emailValidationNotice.value = false;
    phoneValidationNotice.value = false;
    passwordValidationNotice.value = false;
    confirmPasswordValidationNotice.value = false;
    turnstileToken.value = '';
};
defineExpose({
    open,
    close
})
</script>
